import RewardCenterContainer from "./reward-center.container";

export default RewardCenterContainer;